import React,{useState} from "react";

const useLoading = ({loadingInitialValue}) => {

    const [loading,setLoading] = useState(loadingInitialValue);

    return {loading, setLoading};

}

export default useLoading;